import styled from '@emotion/styled';

const StyledBreadCrumb = styled.div`
  width: 100%;
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: block;
    margin-bottom: 24px;
  }

  .breadcrumb {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

const StyledBreadCrumbElement = styled.li`
  position: relative;
  margin-right: 18px;
  color: ${(props) => props.theme.colors.grey._400};

  a,
  span {
    color: inherit;
  }

  &:not(:last-child) {
    display: flex;
    align-items: center;

    :after {
      content: '';
      display: block;
      margin-left: 16px;
      width: 6px;
      height: 6px;
      border-top: 2px solid #ababab;
      border-right: 2px solid #ababab;
      transform: rotate(45deg);
    }
  }
`;

export { StyledBreadCrumb, StyledBreadCrumbElement };
